export const SEARCH_ALERT_LABEL_ID = 'search-alert-banner-toggler';
